import { Add, Delete } from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  LinearProgress,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
} from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useDialogs } from '@work4all/components';

import { useDataProvider, useDeleteEntity } from '@work4all/data';

import { Mailbox } from '@work4all/models/lib/Classes/Mailbox.entity';
import { DataRequest } from '@work4all/models/lib/DataProvider';
import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { LinkMailboxDialog } from '../../../data-tables/LinkMailboxDialog';

const req: DataRequest = {
  entity: Entities.mailbox,
  data: {
    id: null,
    mailboxPrimaryAddress: null,
    mailboxType: null,
    loadErrorType: null,
    loadErrorMessage: null,
  },
  completeDataResponse: true,
};

export const MailboxManagement = () => {
  const { data, refetch, loading } = useDataProvider<Mailbox>(req);
  const { t } = useTranslation();

  const [isLinkMailboxDialogOpen, setLinkMailboxDialogOpen] = useState(false);

  const [deleteEntity] = useDeleteEntity(false);
  const dialogs = useDialogs();

  const handleDeleteMailbox = async (mailbox: Mailbox) => {
    dialogs.confirm({
      title: t('ALERTS.DELETE.TITLE'),
      description: t('ALERTS.DELETE.REASSURE', { count: 1 }),
      confirmLabel: t('ALERTS.YES'),
      cancelLabel: t('ALERTS.NO'),
      onConfirm: async () => {
        await deleteEntity({
          type: Entities.mailbox,
          ids: [mailbox.id],
        });
        refetch();
      },
    });
  };

  return (
    <Box pt="1rem">
      {loading && (
        <LinearProgress sx={{ position: 'absolute', left: 0, right: 0 }} />
      )}
      <LinkMailboxDialog
        open={isLinkMailboxDialogOpen}
        onClose={() => setLinkMailboxDialogOpen(false)}
      />
      <List>
        {data.map((mailbox) => (
          <ListItem key={mailbox.id}>
            <ListItemText primary={mailbox.mailboxPrimaryAddress} />
            <ListItemSecondaryAction>
              <IconButton onClick={() => handleDeleteMailbox(mailbox)}>
                <Delete />
              </IconButton>
            </ListItemSecondaryAction>
          </ListItem>
        ))}
      </List>
      <Box p="0 0.5rem">
        <Button
          onClick={() => setLinkMailboxDialogOpen(true)}
          startIcon={<Add />}
          style={{ width: 'fit-content' }}
        >
          {t('COMMON.ADD', { name: t('COMMON.MAILBOX') })}
        </Button>
      </Box>
    </Box>
  );
};
